import { useEffect, useState } from 'react';
import Icon from '../components/Icon';
import { SHOPPING_GROUPS } from '../components/ShoppingList';
import { useApp } from '../lib/AppContext';

// ⑥ Đi chợ while cooking together: "Gộp 2 người" (both menus' ingredients with each person's amount) or
// "Chỉ của tôi". Ticks are shared, so both phones show the same after a reload.
export default function PairShopping({ weekStart, partnerName }) {
  const { api } = useApp();
  const [scope, setScope] = useState('both');
  const [list, setList] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    setList(null);
    api.get(`/cooking_pair/shopping?week_start=${weekStart}&scope=${scope}`).then(setList).catch((e) => setError(e.message));
  }, [api, weekStart, scope]);

  const tick = async (item) => {
    setList((l) => ({ ...l, groups: l.groups.map((g) => ({ ...g, items: g.items.map((i) => (i.key === item.key ? { ...i, checked: !i.checked } : i)) })) }));
    try {
      setList(await api.post('/cooking_pair/shopping/tick', { week_start: weekStart, key: item.key, checked: !item.checked, scope }));
    } catch (e) {
      window.alert(e.message);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div role="tablist" className="grid grid-cols-2 gap-1 rounded-[14px] bg-base-300/70 p-1">
        {[['both', 'Gộp 2 người'], ['mine', 'Chỉ của tôi']].map(([id, label]) => (
          <button key={id} type="button" role="tab" aria-selected={scope === id} onClick={() => setScope(id)}
            className={`h-10 rounded-[10px] text-sm font-semibold ${scope === id ? 'bg-base-100 shadow-sm' : 'text-muted'}`}>{label}</button>
        ))}
      </div>
      {list?.activity && (
        <p className="flex items-center gap-2 rounded-[14px] bg-base-100 px-3 py-2 text-sm"><Icon name="users" className="size-4 text-[#b2456a]" />{list.activity}</p>
      )}
      {error && <p role="alert" className="text-sm text-error">{error}</p>}
      {!list && !error && <div className="skeleton h-48 rounded-[20px]" />}
      {list && list.groups.length === 0 && list.fallback.length === 0 && (
        <p className="rounded-[20px] bg-base-100 p-5 text-center text-sm text-muted">Chưa có nguyên liệu nào cho tuần này.</p>
      )}
      {list && SHOPPING_GROUPS.map((g) => {
        const group = list.groups.find((x) => x.group === g.key);
        if (!group) return null;
        return (
          <section key={g.key} className="flex flex-col gap-1">
            <h3 className={`text-xs font-bold uppercase tracking-wide ${g.color}`}>{g.label}</h3>
            <ul className="divide-y divide-line rounded-[16px] bg-base-100 px-3">
              {group.items.map((item) => (
                <li key={item.key}>
                  <label className="flex min-h-14 cursor-pointer items-center gap-3 py-2">
                    <input type="checkbox" className="checkbox checkbox-primary size-5 rounded-[6px]" checked={item.checked} onChange={() => tick(item)} />
                    <span className="min-w-0 flex-1">
                      <span className={`block font-semibold ${item.checked ? 'text-muted line-through' : ''}`}>{item.name}</span>
                      {scope === 'both' && (
                        <span className="block text-xs text-muted">
                          {[item.by.me && `Bạn ${item.by.me}`, item.by.partner && `${partnerName} ${item.by.partner}`].filter(Boolean).join(' · ')}
                        </span>
                      )}
                    </span>
                    <span className="tabular font-bold">{item.total}</span>
                  </label>
                </li>
              ))}
            </ul>
          </section>
        );
      })}
      {list?.fallback.map((f) => (
        <section key={f.name} className="flex flex-col gap-1">
          <h3 className="text-xs font-bold uppercase tracking-wide text-muted">Từ thực đơn cũ của {f.name}</h3>
          <ul className="divide-y divide-line rounded-[16px] bg-base-100 px-3 text-sm">
            {f.items.map((i) => <li key={i.name} className="flex justify-between gap-3 py-2"><span>{i.name}</span><span className="text-muted">{i.quantity}</span></li>)}
          </ul>
        </section>
      ))}
      <p className="text-xs text-muted">Gộp nguyên liệu bữa ăn chung và bữa riêng của cả hai, từ ngày bắt đầu nấu chung. Đánh dấu ở máy ai cũng cập nhật cho người kia.</p>
    </div>
  );
}
